import React, { memo, useEffect, useState } from 'react';
import Icon            from './Icon';

const iconMap = {
  0: 'material-symbols-light:error-outline',
  1: 'material-symbols-light:check-circle-outline',
  2: 'material-symbols-light:arrow-circle-right-outline'
}

const stateMap = {
  0: 'inattivo',
  1: 'attivo',
  2: 'pubblico'
}

const bgMap = {
  0: 'warning',
  1: 'success',
  2: 'primary'
}

export default function CryptoPill({ data, _action }) {

  const [ icon, set_icon ] = useState( '' );

  if ( data ) {
    var element = data.metadata.element;
    var weight  = data.metadata.weight;
    var state   = data.state;
    var label   = stateMap[state];

    var displayText = `${label} | ${element}`;
  }

  useEffect( () => {
  }, [ ]);

  return (
    <>
    { data &&
      <div className="crypto-pill" onClick={ () => do_action() } >

        <div className="left">
          <div>{ weight } Gr.</div>
        </div>

        <div className={` right ${bgMap[state]} `}>
          <div className="text">{ displayText }</div>
          <Icon icon={ iconMap[state] } _style="btn-icon-med" />
        </div>
      </div>
    }
    </>
  );

  function do_action () {
    if ( state > 1 ) {
      _action();
    }
  }

};
